module.exports = __webpack_public_path__ + "img/rentCar.a93d43dc.png";